var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0.166656C9.70624 0.166656 0.166656 9.70624 0.166656 21C0.166656 32.2937 9.70624 41.8333 21 41.8333C32.2937 41.8333 41.8333 32.2937 41.8333 21C41.8333 9.70624 32.2937 0.166656 21 0.166656ZM21 10.5833C24.5979 10.5833 27.25 13.2333 27.25 16.8333C27.25 20.4333 24.5979 23.0833 21 23.0833C17.4042 23.0833 14.75 20.4333 14.75 16.8333C14.75 13.2333 17.4042 10.5833 21 10.5833ZM10.3625 30.9417C12.2312 28.1917 15.3479 26.3583 18.9167 26.3583H23.0833C26.6542 26.3583 29.7687 28.1917 31.6375 30.9417C28.975 33.7917 25.1979 35.5833 21 35.5833C16.8021 35.5833 13.025 33.7917 10.3625 30.9417Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.684cb07109bfbbad682c458e242fa106.svg";
export { ForwardRef as ReactComponent };